import moment from "moment";

export const getTime = (startDate, endDate, appLang = "en-us") => {
  if (!startDate) return "";
  const startDateFormatted = moment(startDate)
    .locale(appLang)
    .format("MMM DD h:mm A");
  const endDateFormatted = moment(endDate)
    .locale(appLang)
    .format("MMM DD h:mm A");

  const formNowStart = moment(startDate).locale(appLang).format("h:mm A");
  const formNowEnd = moment(endDate).locale(appLang).format("h:mm A");

  let checkIfToday = moment(startDate).isSame(endDate, "day");
  if (checkIfToday) {
    return `from ${formNowStart} to ${formNowEnd}`;
  } else {
    return `from ${startDateFormatted} to ${endDateFormatted}`;
  }
};
